import React from 'react';
import { createToolkitAction } from 'client/components/toolkit/actions/ToolkitAction';
import { IToolkitActionContext } from 'client/components/toolkit/actions/ToolkitActionContext';
import { ToolkitObject } from 'client/components/toolkit/objects/ToolkitObject';
import { yup } from 'common/validation/initYup';
import { FormFieldsContainer } from 'client/ui/form/field/row/FormFieldsContainer';
import { FormFieldItem } from 'client/ui/form/field/FormFieldItem';
import { InferType } from 'yup';
import { message } from 'antd';
import { TextAreaInput } from 'client/ui/form/input/TextAreaInput';
import { FormOutlined } from '@ant-design/icons';
import {
  HighlightedDeskDossier,
  HighlightedDossierToolkitObject
} from '../../objects/HighlightedDossierToolkitObject';
import { WidgetHighlightedDossiersProfile } from '../../WidgetHighlightedDossiersProfile';
import { set } from 'client/core/data/set';
import { getNetworkErrorMessage } from 'client/core/network/errors/getNetworkErrorMessage';

export const WidgetActionAnnotateHighlightedDossier = createToolkitAction({
  name: 'Modifica note Fascicolo',
  code: 'annotate-highlighted-dossier',
  icon: <FormOutlined />,
  showInBar: false,
  arguments: [
    {
      name: 'Fascicolo da annotare',
      type: [HighlightedDossierToolkitObject]
    }
  ],
  async execute(ctx: IToolkitActionContext, dossierObject: ToolkitObject) {
    let dossier: ToolkitObject<HighlightedDeskDossier> =
      HighlightedDossierToolkitObject.get(dossierObject)!;

    const notes = dossier.data.highlighted?.notes;

    ctx.deskContext.actionMessages.prompt({
      ctx,
      action: WidgetActionAnnotateHighlightedDossier,
      args: [dossier],
      confirmText: notes?.trim() ? 'Aggiorna note' : 'Aggiungi note',
      schema: AnnotateSchema,
      onConfirm,
      initialValues: { notes: notes },
      form: (
        <>
          <FormFieldsContainer>
            <FormFieldItem
              size="large"
              component={TextAreaInput}
              label={null}
              name="notes"
              placeholder="Note"
            />
          </FormFieldsContainer>
        </>
      )
    });
  }
});

async function onConfirm(
  ctx: IToolkitActionContext,
  values: InferType<typeof AnnotateSchema>,
  dossier: ToolkitObject
) {
  try {
    const widget = ctx.deskContext.widgets.find(
      w => w.id === dossier.sourceWidgetId
    );
    const profile = widget?.profile;
    const data = profile?.data as WidgetHighlightedDossiersProfile;
    const index = data.dossiers?.findIndex(d => d.id === dossier.data.id);

    await ctx.deskContext.updateWidget(
      set(
        widget!,
        `profile.data.dossiers.${index}.highlighted.notes`,
        values.notes || null
      )
    );

    message.success('Note aggiornate con successo');
  } catch (e) {
    message.error(
      getNetworkErrorMessage(e, "Errore durante l'aggiornamento delle note")
    );
    console.error(e);
    return false;
  }
}

const AnnotateSchema = yup.object({
  notes: yup.string().notRequired().label('Note')
});
